import React from 'react';
import { FormattedMessage } from 'react-intl';

import { goBack } from 'modules/router/actions';
import { useDispatch } from 'hooks';

import { logout } from 'modules/auth/actions';

import { Button, Icon } from 'components/ui';
import { ButtonType } from 'components/ui/Button';

interface FooterProps {
  hideBackButton?: boolean;
}

const Footer: React.FC<FooterProps> = ({ hideBackButton }) => {
  const dispatch = useDispatch();

  const handleOnBackClick = () => dispatch(goBack());
  const handleOnLogoutClick = () => dispatch(logout(undefined, { asAdmin: true }));

  return (
    <div className="nextButton gap-5">
      {!hideBackButton && (
        <Button type={ButtonType.SECONDARY} onClick={handleOnBackClick} className="min-w-72" testId="btn-back">
          <FormattedMessage id="steps.back" defaultMessage="Back" />
        </Button>
      )}
      <Button onClick={handleOnLogoutClick} className="min-w-72" testId="btn-log-out">
        <div className="flex justify-center items-center gap-3">
          <Icon className="fb-icon--logout-1 text-2xl kiosk:text-4xl text-white" />
          <FormattedMessage id="socket.updateLogoutModal.logOut" defaultMessage="Logout" values={{ countdown: 0 }} />
        </div>
      </Button>
    </div>
  );
};

export default Footer;
